/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum SystemEventType {
  autoUpdateCandidateBookDirectOffer = "autoUpdateCandidateBookDirectOffer",
  autoUpdateProfileStatus = "autoUpdateProfileStatus",
  cancelConversation = "cancelConversation",
  clearCache = "clearCache",
  daily = "daily",
  deleteCandidatesSavedOpportunities = "deleteCandidatesSavedOpportunities",
  deleteExpiredTokens = "deleteExpiredTokens",
  loadRecommended = "loadRecommended",
  reindex = "reindex",
  reindexJava = "reindexJava",
  seeding = "seeding",
  updateTos = "updateTos",
  cronJob = "cronJob",
}

export const SystemEventTypeDisplay: Record<SystemEventType, string> = {
  [SystemEventType.autoUpdateCandidateBookDirectOffer]: "Auto Update Candidate Book Direct Offer",
  [SystemEventType.autoUpdateProfileStatus]: "Auto Update Profile Status",
  [SystemEventType.cancelConversation]: "Cancel Conversation",
  [SystemEventType.clearCache]: "Clear Cache",
  [SystemEventType.daily]: "Daily",
  [SystemEventType.deleteCandidatesSavedOpportunities]: "Delete Candidates Saved Opportunities",
  [SystemEventType.deleteExpiredTokens]: "Delete Expired Tokens",
  [SystemEventType.loadRecommended]: "Load Recommended",
  [SystemEventType.reindex]: "Reindex",
  [SystemEventType.reindexJava]: "Reindex Java",
  [SystemEventType.seeding]: "Seeding",
  [SystemEventType.updateTos]: "Update Tos",
  [SystemEventType.cronJob]: "Cron Job",
};
